/*
 * The overall structure is <trading platform>_<stock symbol>.
 * SWX = Swiss Stock Exchange
 * OTCMKTS = OTC Markets
 * RHHBY = Roche Holding AG
 * RO = Roche Bearer share
 * ROG = Roche Non-Voting Equity Security
 */
export enum StockInformationCategory {
  OTCMKTS_RHHBY = 'OTCMKTS_RHHBY',
  SWX_RO = 'SWX_RO',
  SWX_ROG = 'SWX_ROG',
}

export interface StockInformationSearchParams {
  category: StockInformationCategory,
}
